import cx from 'classnames'

import type { PropsWithChildren } from 'react'

import { LIST_SIZE } from '@/blocks/constants'
import { builderLightText } from '@/blocks/utils'
import { Container, type BackgroundColor, type Space } from '@/components/Container'
import {
  HeadingM,
  HeadingS,
  SubHeading,
  type TypographyColorModifier,
} from '@/components/Typography'
import type { TitleProps } from '@/models'

import type { ContainerMaxWidth } from '../Container/Container'

export type MediaContainerProps = {
  id?: string
  title: TitleProps
  subtitle: TitleProps
  background: BackgroundColor
  backgroundColor?: string
  position: 'right' | 'center' | 'left'
  size: 'm' | 'l'
  space: Space
  containerSize?: ContainerMaxWidth
  className?: string
  spaceIn?: Space
  colorModifier?: TypographyColorModifier
}

const MediaContainer = ({
  id,
  title,
  subtitle,
  background,
  position,
  space,
  size = 'l',
  children,
  containerSize = 'md',
  className,
  spaceIn = 'm',
  colorModifier,
  backgroundColor,
}: PropsWithChildren<MediaContainerProps>) => {
  const TitleComponent = size === LIST_SIZE.lg ? HeadingM : HeadingS
  const lightText = builderLightText(colorModifier)

  return (
    <Container
      maxWidth={containerSize}
      backgroundColor={background}
      spaceOut={space}
      spaceIn={spaceIn}
      id={id}
      contentClassName={className}
      backgroundColorHex={backgroundColor}
    >
      {(title || subtitle) && (
        <div className={cx('eu-sm-4-r', `et-ta-${position}`)}>
          {title && title.text && (
            <TitleComponent
              light={lightText}
              dark="high"
              tag={title.tag || 'h2'}
              className="eu-sm-1"
            >
              {title.text}
            </TitleComponent>
          )}

          {subtitle && subtitle.text && (
            <SubHeading light={lightText} dark="medium" tag={subtitle.tag || 'h3'}>
              {subtitle.text}
            </SubHeading>
          )}
        </div>
      )}

      {children}
    </Container>
  )
}
export default MediaContainer
